import classNames from 'classnames';
import { omit } from 'lodash-es';
import type { PropsWithChildren } from 'react';

type Level = 1 | 2 | 3;
type HeadingTagName = `h${Level}`;

type HeadingProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>;

const createHeadingComponent = (level: Level, className?: string) => (props: PropsWithChildren<HeadingProps>) => {
  const TagName: HeadingTagName = `h${level}`;
  return (
    <TagName className={classNames('leading-tight', className, props.className)} {...omit(props, 'level', 'className')}>{props.children}</TagName>
  );
};

export const Heading1 = createHeadingComponent(1, 'text-xl');
export const Heading2 = createHeadingComponent(2, 'text-lg');
export const Heading3 = createHeadingComponent(3);
